import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Konto',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Zarządzaj kontem',
      description: 'Aktualizuj swoje konto i zarządzaj ustawieniami.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Metody płatności',
      description: 'Dodaj, zmień lub wybierz preferowaną metodę płatności.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Pomoc i FAQ',
    },
    [AccountItemEnum.Logout]: {
      title: 'Wyloguj się',
    },
    [AccountItemEnum.Language]: {
      title: 'Język',
    },
  },
};
